import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Star, MapPin, ListChecks, PenLine } from "lucide-react";

function Stars({ n }) {
  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          className={`w-4 h-4 ${i <= Math.round(n) ? "fill-[#F5B301] text-[#F5B301]" : "text-slate-300"}`}
        />
      ))}
    </div>
  );
}

export default function Reviews() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api
      .get("/reviews")
      .then((r) => setData(r.data))
      .catch(() => setData({ configured: false, reviews: [] }));
  }, []);

  if (!data) return null;

  return (
    <section data-testid="google-reviews-section" className="px-4 py-8">
      <div className="text-center mb-5">
        <p className="text-xs font-semibold tracking-widest uppercase text-[#F5B301]">Google</p>
        <h2 className="font-heading text-2xl font-bold text-navy mt-1">
          Avaliações dos nossos clientes
        </h2>
      </div>

      {data.configured && data.rating && (
        <div data-testid="google-rating-summary" className="flex items-center justify-center gap-3 mb-5">
          <span className="font-heading text-4xl font-extrabold text-navy">{data.rating.toFixed(1)}</span>
          <div>
            <Stars n={data.rating} />
            <p className="text-xs text-slate-500 mt-0.5">{data.total} avaliações no Google</p>
          </div>
        </div>
      )}

      {data.reviews.length > 0 && (
        <div className="space-y-3 mb-5">
          {data.reviews.slice(0, 3).map((rev, i) => (
            <div key={i} data-testid={`review-card-${i}`} className="bg-white rounded-2xl p-4 border border-slate-100 shadow-sm">
              <div className="flex items-center gap-3 mb-2">
                {rev.photo ? (
                  <img src={rev.photo} alt={rev.author} className="w-9 h-9 rounded-full object-cover" />
                ) : (
                  <div className="w-9 h-9 rounded-full bg-navy text-gold flex items-center justify-center font-heading font-bold text-sm">
                    {rev.author?.[0] || "C"}
                  </div>
                )}
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-navy truncate">{rev.author}</p>
                  <div className="flex items-center gap-2">
                    <Stars n={rev.rating} />
                    {rev.time && <span className="text-[11px] text-slate-400">{rev.time}</span>}
                  </div>
                </div>
              </div>
              {rev.text && <p className="text-sm text-slate-600 leading-relaxed line-clamp-3">{rev.text}</p>}
            </div>
          ))}
        </div>
      )}

      {!data.configured && (
        <p className="text-center text-sm text-slate-500 mb-5" data-testid="reviews-fallback-text">
          Confira as avaliações reais dos nossos clientes diretamente no perfil oficial do Google.
        </p>
      )}

      <div className="space-y-2.5">
        <a
          data-testid="ver-todas-avaliacoes-btn"
          href={data.reviews_url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 w-full py-3.5 rounded-xl bg-navy text-white font-semibold text-sm active:scale-95 transition-transform"
        >
          <ListChecks className="w-4 h-4 text-[#F5B301]" />
          VER TODAS AS AVALIAÇÕES
        </a>
        <a
          data-testid="google-maps-reviews-btn"
          href={data.maps_url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 w-full py-3.5 rounded-xl bg-white border-2 border-navy text-navy font-semibold text-sm active:scale-95 transition-transform"
        >
          <MapPin className="w-4 h-4" />
          VER NO GOOGLE MAPS
        </a>
        <a
          data-testid="avaliar-google-btn"
          href={data.maps_url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 w-full py-3 rounded-xl text-[#F5B301] font-semibold text-sm"
        >
          <PenLine className="w-4 h-4" />
          Já fez um frete conosco? Avalie no Google
        </a>
      </div>
    </section>
  );
}
